(function () {
  if (window.__xsOrto) return;
  window.__xsOrto = true;

  document.addEventListener(
    'click',
    function (e) {
      // "Arata altele" - schimba cele 2 recomandari vizibile cu urmatoarele 2
      var swap = e.target.closest('.xs-swap');
      if (swap) {
        e.preventDefault();
        var w = swap.closest('.wt-cart__cross-sell');
        if (w) {
          w.querySelectorAll('.xs-cs-card').forEach(function (c) {
            c.classList.toggle('xs-hide');
          });
        }
        return;
      }

      // Add to cart direct din card, fara reload - reface drawer-ul prin Section Rendering
      var btn = e.target.closest('.xs-add-btn');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('xs-loading');

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(btn.dataset.vid),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (d) {
          if (d.sections && d.sections['cart-drawer']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = d.sections['cart-drawer'];
            var fresh = tmp.querySelector('#CartDrawer');
            var cur = document.getElementById('CartDrawer');
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          }
          if (d.sections && d.sections['cart-icon-bubble']) {
            var bub = document.getElementById('cart-icon-bubble');
            if (bub) {
              var t2 = document.createElement('div');
              t2.innerHTML = d.sections['cart-icon-bubble'];
              var nb = t2.querySelector('#cart-icon-bubble') || t2.firstElementChild;
              if (nb) bub.innerHTML = nb.innerHTML;
            }
          }
        })
        .catch(function (err) {
          console.error('[XS]', err);
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('xs-loading');
        });
    },
    true
  );
})();
